export default "<svg class=\"icon icon-{{ vm.name }}\">\n  <use xlink:href=\"\" ng-attr-xlink:href=\"{{ '#' + vm.name | trustedUrl }}\"></use>\n</svg>\n";